import { useElement } from '@carvana/merch-react-hooks';
import { useMemo } from 'react';
import Section from '~/constants/vdp/section';
import { useSectionMounted } from '~/context/vdp/UiContext';

export default function useEventElements() {
  const includePriceDetails = useSectionMounted(Section.PriceDetails);

  const localElement = useElement('#vdp-events');
  const priceDetailsElement = useElement(
    includePriceDetails ? '#price-details-events' : ''
  );

  return useMemo(
    () => [localElement, priceDetailsElement],
    [localElement, priceDetailsElement]
  );
}
